import * as APITypes from "~/API";

/**
 * Check if a resource type can have children
 * @param resourceType - The entity type to check
 * @returns true if the resource type can have children
 */
export const resourceTypeHasChildren = (
  resourceType: APITypes.EntityType | null
): boolean => {
  if (!resourceType) return false;

  return (
    resourceType === APITypes.EntityType.Property ||
    resourceType === APITypes.EntityType.Building ||
    resourceType === APITypes.EntityType.Unit ||
    resourceType === APITypes.EntityType.Parcel
  );
};

/**
 * Get a human-readable description of what children a resource type has
 * @param resourceType - The entity type to check
 * @returns Description of the children types
 */
export const getResourceChildrenDescription = (
  resourceType: APITypes.EntityType
): string => {
  switch (resourceType) {
    case APITypes.EntityType.Property:
      return "This will grant access to all buildings, parcels, units, amenities, stays, and service requests under this property.";
    case APITypes.EntityType.Building:
      return "This will grant access to all units, stays, and service requests under this building.";
    case APITypes.EntityType.Unit:
      return "This will grant access to all stays and service requests for this unit.";
    case APITypes.EntityType.Parcel:
      return "This will grant access to all stays and service requests for this parcel.";
    default:
      return "";
  }
};
